import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { message, Descriptions, Image, Table } from "antd";
import { EditOutlined } from "@ant-design/icons";

import { getFileUrl } from "../../api/file";
import { UserRole } from "../../lib/constants";

import PageHeader from "../../components/shared/PageHeader";
import LoadingModal from "../../components/shared/LoadingModal";
import BlueButton from "../../components/shared/BlueButton";
import { cn } from "../../lib/utils";
import { getClient } from "../../api/client";

export default function ClientView({ user }) {
  const { clientId } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [client, setClient] = useState(null);
  const [documents, setDocuments] = useState([]);
  const navigate = useNavigate();

  const fetchClient = async ({ clientId }) => {
    setLoading(true);
    try {
      const res = await getClient(clientId);
      setClient(res);
      if (res.attachments && res.attachments.length > 0) {
        updateDocuments(res);
      }
    } catch (err) {
      console.error(err);
      message.error("Something went wrong");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchClient({ clientId });
  }, [clientId]);

  const updateDocuments = (client) => {
    const docs = [];
    client?.attachments.forEach((doc, index) => {
      if (doc.isActive) {
        docs.push(
          {
            key: `${doc.id + index}`,
            label: "Document Name",
            children: doc.name,
          },
          {
            key: `${doc.id + index}`,
            label: "Document",
            children: doc.file.name,
            span: 2,
          },
        );
      }
    });
    setDocuments(docs);
  };

  const contactColumn = [
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
  ]

  const items = !client
    ? []
    : [
      {
        key: "1",
        label: "Name",
        children: client.name || "",
      },
      {
        key: "2",
        label: "Trading Name",
        children: client.tradingName || "",
        span: 2,
      },
      {
        key: "3",
        label: "Description",
        children: client.description,
        span: 3
      },
      {
        key: "4",
        label: "Address",
        children: client.address.name
      },
      {
        key: "5",
        label: "Address Line 1",
        children: client.address.addressLine1
      },
      {
        key: "addressLine2",
        label: "Address Line 2",
        children: client.address.addressLine2
      },
      {
        key: "6",
        label: "Latitude",
        children: client.address.lat || "N/A",
      },
      {
        key: "7",
        label: "Longitude",
        children: client.address.long || "N/A",
        span: 2,
      },
      {
        key: "8",
        label: "Attachments",
        labelStyle: { border: "0" },
        contentStyle: { backgroundColor: "rgba(0, 0, 0, 0.02)" },
        span: 3,
      },

      ...documents,
    ];

  if (!client) return <LoadingModal />;

  return (
    <main className="space-y-6 min-h-full flex flex-col">
      <PageHeader title={client.name} home="Clients" route="/clients" />

      <div
        className={cn(
          "flex-grow bg-white ml-6 p-6 relative",
          !client.avatar && "pt-20",
        )}
      >
        <section className="space-y-6">
          {client && client.avatar && (
            <Image
              src={getFileUrl(client.avatar)}
              width={245}
              height={245}
              style={{ objectFit: "cover" }}
            />
          )}
          <Descriptions items={items} className="rounded-none" bordered />
          <Table
            bordered
            title={() => <div className="flex justify-between items-center">
              <div>Contacts</div>

            </div>}
            columns={contactColumn}
            dataSource={client.contacts.filter((c) => c.isActive)}
            className="pb-6"
            pagination={false}
          />

        </section>

        {user?.role !== UserRole.AccountManager && (
          <BlueButton
            className="absolute right-6 top-5  flex items-center"
            type="primary"
            onClick={() => navigate(`/clients/form/${client.id}`)}
          >
            <EditOutlined />
            Edit Client
          </BlueButton>
        )}

        {isLoading && <LoadingModal />}
      </div>
    </main>
  );
}
